export function navigateToPortalLogin() {
  document.cookie = 'PORTAL_TOKEN=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;';
  document.location.href = process.env.VUE_APP_PORTAL_BASE + '/login';
}